import {
  Directive,
  InjectionToken,
  Injector,
  afterNextRender,
  contentChildren,
  inject,
  input,
} from '@angular/core';
import { OnyxFormMode } from '../enums';
import type { OnyxBaseFormControlComponent } from '../internal/components/onyx-base-form-control/onyx-base-form-control.component';

export type OnyxFocusable = Pick<
  OnyxBaseFormControlComponent,
  'disabled' | 'readonly' | 'hidden'
> & {
  focus: () => void;
};

export const ONYX_FOCUSABLE = new InjectionToken<OnyxFocusable>(
  'Onyx Focusable',
);

@Directive({
  selector: '[onyxAutoFocus]',
})
export class OnyxAutoFocusDirective {
  private readonly focusableElements = contentChildren(ONYX_FOCUSABLE, {
    descendants: true,
  });
  private readonly injector = inject(Injector);

  public readonly onyxAutoFocus = input.required<boolean | OnyxFormMode>();

  constructor() {
    afterNextRender(
      () => {
        const autoFocus = this.onyxAutoFocus();
        if (!autoFocus || autoFocus === OnyxFormMode.EDIT) return;

        this.focusableElements()
          .find(
            (element) =>
              !element.disabled() && !element.readonly() && !element.hidden(),
          )
          ?.focus();
      },
      { injector: this.injector },
    );
  }
}
